import { initProductBuyTile } from '../../../snippets/product-buy-tile/product-buy-tile';

export const initFramesSectionTiles = () => {
  const framesProductEls = document.querySelectorAll(
    '[data-list-collections-frames-product]'
  );

  framesProductEls.forEach((productEl) => {
    const productId = productEl.getAttribute(
      'data-list-collections-frames-product'
    );

    if (productId) {
      initProductBuyTile(productId);
    }
  });
};
